import type { SVGProps } from 'react';

/**
 * A film clapperboard with a play triangle. Drawn to match heroicons 24/outline (24x24 box, 1.5
 * stroke, currentColor); heroicons has no clapperboard and `FilmIcon` reads as a strip of film.
 */
export const ClapperboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    data-slot="icon"
    {...props}
  >
    {/* The board. */}
    <path d="M3.75 10.5h16.5v8.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V10.5Z" />
    {/* The clapper, hinged open at its left end, with two stripes. */}
    <g transform="rotate(-12 3.75 10.5)">
      <rect x="3.75" y="7" width="16.5" height="3.5" rx="1" />
      <path d="M8.5 7l-1.75 3.5M13.5 7l-1.75 3.5M18.5 7l-1.75 3.5" />
    </g>
    {/* Play. */}
    <path d="M10.25 13.5v4.5l4.25-2.25-4.25-2.25Z" />
  </svg>
);
